import React from 'react';
import { Link, useParams } from 'react-router-dom';
import cn from '@/utils/cn';
import RoutedSPADialog from '../../shared/RoutedSPADialog';
import SPADialog from '../../shared/SPADialog';
import { useProgramSummaries } from '../../shared/ProgramTree/usePrograms';
import { programLessonsPath, useContentMount } from '../contentMount';
import useProgramLessons from './useProgramLessons';

const linkClass = cn(
  'tw-text-spa-accent-text hover:tw-text-spa-accent-text-hover',
  'tw-no-underline tw-transition-colors',
);

// SPA counterpart of the legacy admin/ProgramUses modal, mounted as a child route
// (/content/programs/:programId/lessons/:lessonId/shared-programs).
const SharedProgramsModal = () => {
  const { lessonId, programId } = useParams<{ lessonId: string; programId: string }>();
  const pid = Number(programId);
  const { allLessons } = useProgramLessons(pid);
  const { data: programs = {} } = useProgramSummaries();
  const mount = useContentMount();

  const lesson = allLessons.find(l => l.id === Number(lessonId));
  const programIds = lesson?.program_ids || [];
  const otherPrograms = programIds
    .filter(id => id !== pid)
    .map(id => ({ id, title: programs[id]?.title || `Program ${id}` }))
    .sort((a, b) => a.title.localeCompare(b.title));

  return (
    <RoutedSPADialog>
      <SPADialog.Content size="sm">
        <SPADialog.Header>
          <SPADialog.Title>Shared Programs</SPADialog.Title>
          <SPADialog.CloseButton />
        </SPADialog.Header>
        <SPADialog.Body>
          {lesson && (
            <>
              <p className="tw-m-0 tw-mb-6 tw-text-sm">
                <em>{lesson.title_with_position}</em> is used in {programIds.length} programs.
              </p>
              <p className="tw-m-0 tw-mb-2 tw-text-sm">{programs[pid]?.title || `Program ${pid}`}</p>
              {otherPrograms.map(program => (
                <p key={program.id} className="tw-m-0 tw-my-2 tw-text-sm">
                  <Link className={linkClass} to={programLessonsPath(program.id, mount)}>
                    {program.title}
                  </Link>
                </p>
              ))}
            </>
          )}
        </SPADialog.Body>
        <SPADialog.Footer>
          <SPADialog.Close asChild>
            <SPADialog.Button>Close</SPADialog.Button>
          </SPADialog.Close>
        </SPADialog.Footer>
      </SPADialog.Content>
    </RoutedSPADialog>
  );
};

export default SharedProgramsModal;
